"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE_NAMES = exports.MARKET_LOCALE_MAP = exports.LOCALES_SET = exports.LOCALES = exports.getDefaultLocale = void 0;
// Globally true default
function getDefaultLocale() {
    return 'en-US';
}
exports.getDefaultLocale = getDefaultLocale;
/**
 * BASE LOCALES
 * All uniquely localizable content
 */
exports.LOCALES = [
    'en-US',
    'ar-AE',
    'da-DK',
    'de-DE',
    'es-ES',
    'es-MX',
    'fr-CA',
    'fr-FR',
    'hi-IN',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NO',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'vi-VN',
    'zh-CN',
    'zh-TW' // Traditional Chinese - Taiwan
];
// Setup set for faster lookups
exports.LOCALES_SET = new Set(exports.LOCALES);
/**
 * MARKET LOCALE MAP
 * This provides a mapping of market to locales,
 * and fallback map if localized content is not available.
 */
exports.MARKET_LOCALE_MAP = {
    'ar-AE': 'en-US',
    'da-DK': 'en-US',
    'de-AT': 'de-DE',
    'de-CH': 'de-DE',
    'de-DE': 'en-US',
    'el-GR': 'en-US',
    'en-AE': 'en-US',
    'en-AU': 'en-US',
    'en-CA': 'en-US',
    'en-GB': 'en-US',
    'en-HK': 'en-US',
    'en-IE': 'en-US',
    'en-IL': 'en-US',
    'en-IN': 'en-US',
    'en-MY': 'en-US',
    'en-NZ': 'en-US',
    'en-PH': 'en-US',
    'en-PK': 'en-US',
    'en-SG': 'en-US',
    'en-ZA': 'en-US',
    'es-AR': 'es-MX',
    'es-CL': 'es-MX',
    'es-CO': 'es-MX',
    'es-ES': 'es-MX',
    'es-MX': 'en-US',
    'es-PE': 'es-MX',
    'es-US': 'es-MX',
    'es-VE': 'es-MX',
    'fi-FI': 'en-US',
    'fr-BE': 'fr-FR',
    'fr-CH': 'fr-FR',
    'fr-CA': 'fr-FR',
    'fr-FR': 'en-US',
    'hi-IN': 'en-US',
    'id-ID': 'en-US',
    'it-CH': 'it-IT',
    'it-IT': 'en-US',
    'ja-JP': 'en-US',
    'ko-KR': 'en-US',
    'nb-NO': 'en-US',
    'nl-BE': 'nl-NL',
    'nl-NL': 'en-US',
    'pl-PL': 'en-US',
    'pt-BR': 'en-US',
    'pt-PT': 'pt-BR',
    'ru-RU': 'en-US',
    'sv-SE': 'en-US',
    'th-TH': 'en-US',
    'tr-TR': 'en-US',
    'uk-UA': 'en-US',
    'vi-VN': 'en-US',
    'zh-CN': 'en-US',
    'zh-HK': 'zh-TW',
    'zh-SG': 'zh-CN',
    'zh-TW': 'en-US'
};
exports.LOCALE_NAMES = {
    'ar-AE': 'Arabic (United Arab Emirates)',
    'da-DK': 'Danish (Denmark)',
    'de-DE': 'German (Germany)',
    'en-US': 'English (United States)',
    'es-ES': 'Spanish (Spain)',
    'es-MX': 'Spanish (Mexico)',
    'fr-CA': 'French (Canada)',
    'fr-FR': 'French (France)',
    'hi-IN': 'Hindi (India)',
    'id-ID': 'Indonesian (Indonesia)',
    'it-IT': 'Italian (Italy)',
    'ja-JP': 'Japanese (Japan)',
    'ko-KR': 'Korean (Korea)',
    'nb-NO': 'Norwegian Bokmal (Norway)',
    'nl-NL': 'Dutch (The Netherlands)',
    'pl-PL': 'Polish (Poland)',
    'pt-BR': 'Portuguese (Brazil)',
    'pt-PT': 'Portuguese (Portugal)',
    'sv-SE': 'Swedish (Sweden)',
    'th-TH': 'Thai (Thailand)',
    'tr-TR': 'Turkish (Turkey)',
    'uk-UA': 'Ukrainian (Ukraine)',
    'vi-VN': 'Vietnamese (Vietnam)',
    'zh-CN': 'Chinese (Simplified, China)',
    'zh-TW': 'Chinese (Traditional, Taiwan)'
};
